<template>
  <div style="width: 100%">
    <div :id="pageId">
      <div v-for="(card, index) in cards" 
           :key="index" 
           class="label-card" 
           :style="cardStyle">

            <div style="position:absolute; top:2mm; right:3mm; font-size:7pt; font-weight:bold;">
    {{ index + 1 }}
  </div>

        <div style="display:flex; width:100%; height:100%; justify-content:space-between; align-items: flex-start;">

         
        <div style="width:70%; margin-top:3mm; line-height:1; font-family: Arial, Helvetica, sans-serif; font-size: 8pt; text-transform: uppercase; color: #000;">

            <!-- 1. Partner Code (Bold) -->
            <div style="font-weight: bold; font-size: 8pt; margin-bottom: 2px;">
              {{ card.code }}
            </div>

            <!-- 2. Partner Name (Bold) -->
            <div style="font-weight: bold; font-size: 8pt; margin-bottom: 3px;">
              {{ card.title }} {{ card.firstName }} {{ card.lastName }}
            </div>

            <!-- 3. Address Lines -->
            <div v-if="card.addressLine1">{{ card.addressLine1 }}</div>
            <div v-if="card.addressLine2">{{ card.addressLine2 }}</div>
            <div v-if="card.addressLine3">{{ card.addressLine3 }}</div>

            <!-- 4. District (Separate Line) -->
            <div v-if="card.district">{{ card.district }}</div>

            <!-- 5. State (Separate Line) -->
            <div v-if="card.state">{{ card.state }}</div>

            <!-- 6. PIN (Separate Line - Bold) -->
            <div style="font-weight: bold;">PIN: {{ card.pincode }}</div>

            <!-- 7. Phone (If available) -->
            <div v-if="card.phone">PHONE: {{ card.phone }}</div>
          </div>

          <!-- RIGHT SIDE: QR Code aligned to top-right -->
   <div style="width:25%; display:flex; flex-direction: column; align-items:flex-end; justify-content:center; height:100%; margin-top:6mm;">
            <qrcode-vue
              :size="65" 
              render-as="svg"
              :value="`${card.code}
${card.title || ''} ${card.firstName || ''} ${card.lastName || ''}
${card.addressLine1 || ''}
${card.addressLine2 || ''}
${card.addressLine3 || ''}
${card.district || ''}
${card.state || ''}
PIN:${card.pincode || ''}
PHONE:${card.phone || ''}`"
              level="M">
            </qrcode-vue>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import {generateRandomString} from "@/utils/AppStringUtils";
import {SUPER_ADMINISTRATORS_ROLES} from "@/dashboard/members/members";
export default {
	name: "AddressPrintingPage",
	components: {QrcodeVue},
	data(){
		return {
			pageId: generateRandomString(8),
			cardStyle: {
        width: "100mm",
        height: "50mm",
        padding: "4mm 6mm 4mm 8mm", // Adjusted padding for physical label margins
        boxSizing: "border-box",
        display: "block", // Changed to block for better top-to-bottom flow
        pageBreakAfter: "always",
        position: "relative"
        
      },
		}
	},
	props: {
		content: {
			required: true,
			type: Array,
			default: () => []
		}
	},
	computed: {
		cards() {
      return this.content.filter(card => card !== null);
    },
		institution() {
			let loggedInUser = this.$store.getters.getLoggedInUser;
			if(SUPER_ADMINISTRATORS_ROLES.includes(loggedInUser.userType)){
				return this.$store.getters.getInstitution;
			}
			return loggedInUser.institution;
		}
	}
}
</script>


<style lang="scss">
</style>